<template>
  <div id="app">
    <ConfigProvider :locale="locale">
      <router-view />
    </ConfigProvider>
  </div>
</template>

<script>
// import {configProvider,Provider} from 'ant-design-vue';
import {ConfigProvider} from 'ant-design-vue';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import 'ant-design-vue/dist/antd.css';
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
    }
  },
  components:{
    ConfigProvider
  },
  created(){
    // 二十分钟无操作退出登录
    var timer = null
    var that = this
    clearInterval(timer)
    var lastTime = new Date().getTime() // 最后一次点击时间
    var currentTime = new Date().getTime() // 当前时间
    var timeOut = 20 * 60 * 1000 // 允许最长未操作时间
    var i = 1 // 辅助作用

    function handleReset() { // 重新赋值最后一次点击时间，清除定时器，重新开始定时器
      // console.log('又点击了！！！！！！')
      i = 1

      lastTime = new Date().getTime()

      if (timer) {
        clearInterval(timer)
        timer = null
      }

      if (!timer) {
        // console.log('真好！重新开始')
        handleInterval()
      }
    }

    document.onclick = () => { // 单击事件
      handleReset()
    }

    document.ondblclick = () => { // 双击事件
      handleReset()
    }

    document.onmousedown = () => { // 按下鼠标键时触发
      handleReset()
    }

    document.onmouseup = () => { // 释放按下的鼠标键时触发
      handleReset()
    }

    document.onmousemove = () => { // 鼠标移动事件
      handleReset()
    }

    document.onmouseover = () => { // 移入事件
      handleReset()
    }

    document.onmouseout = () => { // 移出事件
      handleReset()
    }

    document.onmouseenter = () => { // 移入事件
      handleReset()
    }

    document.onmouseleave = () => { // 移出事件
      handleReset()
    }

    function handleInterval() { // 定时器
      timer = setInterval(() => {
        currentTime = new Date().getTime() // 当前时间
        if (currentTime - lastTime > timeOut) {
          clearInterval(timer) // 清除定时器
          if(that.$route.path!='/'){
            that.$router.push('/')
            sessionStorage.canLogin = ""
            sessionStorage.user_id = ''
            location.reload()
            that.$post(that.url + that.hostAuth + '/logout'
            // }
            ).then(res=>{
              if(res.response.code == "S0A00000") {
              } else {
                that.$message({
                  type: 'warning',
                  message: res.response.desc
                })
              }
            })
          }
        }
      }, 1000)
    }
    if(that.$route.path!='/'){
      handleInterval() // 一开始程序 默认执行定制器
    }
  }
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue